<template>
  <div>
    <!-- Modal -->
    <div id="modal_aside_right" class="modal fixed-left fade" role="dialog">
      <div class="modal-dialog modal-dialog-aside" role="document">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h5 class="modal-title text-white">Movimientos Guías</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group col-md-12">
              <label for="origen">Sitio Origen</label>
              <v-select
                :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                v-model="sitioOrigen"
                placeholder="Sitio Origen"
                label="nombre"
                :options="listasForms.sitiosOrigenes"
                :filterable="false"
                @search="buscarSitioOrigen"
                @input="selectSitioOrigen()"
              ></v-select>
            </div>
            <div class="form-group col-md-12">
              <label for="destino">Sitio Destino</label>
              <v-select
                :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                v-model="sitioDestino"
                placeholder="Sitio Destino"
                label="nombre"
                :options="listasForms.sitiosDestinos"
                :filterable="false"
                @search="buscarSitioDestino"
                @input="selectSitioDestino()"
              ></v-select>
            </div>
            <div class="row">
              <div class="col-md-7"></div>
              <div class="col-md-5">
                <div class="form-group">
                  <label class="form__label" for="hasDesc"
                    >Guías unitarias?</label
                  >
                  <div class="float-right pr-2">
                    <input
                      id="hasDesc"
                      type="checkbox"
                      v-model="hasDescription"
                    />
                    <!-- @change="[form.guia_unitaria = null, form.guia_inicial = null, form.guia_final = null]" -->
                    <label for="hasDesc">
                      <div class="toggle__switch"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="!hasDescription">
              <div class="col-md-6">
                <label for="guia_inicial"># Guía Inicial</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  id="guia_inicial"
                  placeholder="# Guía"
                  v-model="form.guia_inicial"
                  :class="
                    $v.form.guia_inicial.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
              </div>
              <div class="col-md-6">
                <label for="guia_final"># Guía Final</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  id="guia_final"
                  placeholder="Guia Final"
                  v-model="form.guia_final"
                  :class="
                    $v.form.guia_final.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
              </div>
            </div>
            <div class="col-lg-12" v-if="hasDescription">
              <div class="form-group">
                <input
                  type="number"
                  class="form-control form-control-sm"
                  id="guia_unitaria"
                  placeholder="Guia Unitaria"
                  v-model.trim="form.guia_unitaria"
                  :class="
                    $v.form.guia_unitaria.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-dark"
                  style="cursor: pointer"
                  @click="guiasOrigen"
                  v-show="!$v.form.$invalid"
                >
                  Buscar Guías
                  <i class="fab fa-searchengin"></i>
                </button>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-md-12">
                <div class="card-body p-0">
                  <table
                    class="table table-bordered table-striped table-hover table-sm"
                  >
                    <tbody>
                      <tr v-for="item in guias" :key="item.id">
                        <td>
                          {{ item.numero }} - {{ item.digito_verificacion }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              v-if="!$v.form.$invalid && guias.length > 0"
              class="btn btn-primary"
              @click="trasladoGuias()"
            >
              Trasladar Guías
            </button>
          </div>
        </div>
      </div>
      <!-- modal-bialog .// -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";

export default {
  name: "GuiaMovimiento",
  components: {
    vSelect,
  },
  data() {
    return {
      form: { sitio_origen_id: null, sitio_destino_id: null },
      filtros: {
        sitio_origen_id: null,
        guia_unitaria: null,
      },
      arrayGuias: [],
      sitioOrigen: [],
      sitioDestino: [],
      listasForms: {
        sitiosOrigenes: [],
        sitiosDestinos: [],
      },
      guias: [],
      hasDescription: false,
    };
  },
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          sitio_origen_id: {
            required,
          },
          sitio_destino_id: {
            required,
          },
          guia_final: {
            required,
          },
          guia_inicial: {
            required,
          },
        },
      };
    } else {
      return {
        form: {
          sitio_origen_id: {
            required,
          },
          sitio_destino_id: {
            required,
          },
          guia_unitaria: {
            required,
          },
        },
      };
    }
  },
  methods: {
    trasladoGuias() {
      this.form.guias = this.guias;
      if (!this.$v.form.$invalid) {
        axios({
          method: "POST",
          url: "/api/hidrocarburos/guias/saveTraslado",
          data: this.form,
        })
          .then(() => {
            this.form = {};
            this.guias = [];
            this.filtros = {};
            this.sitioOrigen = [];
            this.sitioDestino = [];
            this.$parent.getIndex();
            this.$refs.closeModal.click();
            this.$swal({
              icon: "warning",
              title: "El traslado se efectuo exitosamente",
              text: "Tenga en cuenta que este traslado debe ser autorizado.",
              showConfirmButton: true,
            });
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    guiasOrigen() {
      this.filtros.sitio_origen_id = null;
      if (this.sitioOrigen) {
        this.filtros.sitio_origen_id = this.sitioOrigen.id;
        this.filtros.guia_inicial = this.form.guia_inicial;
        this.filtros.guia_final = this.form.guia_final;
        this.filtros.guia_unitaria = this.form.guia_unitaria;
      }
      axios
        .get("/api/hidrocarburos/guias/guiasMover", {
          params: this.filtros,
        })
        .then((response) => {
          this.guias = response.data;
          if (this.guias.mensaje) {
            this.$swal({
              icon: "error",
              title: this.guias.mensaje,
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 8000,
              timerProgressBar: true,
            });
          }
        });
    },

    buscarSitioOrigen(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/sitios/lista?sitio=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listasForms.sitiosOrigenes = respuesta;
            me.form.sitio_origen_id = me.listasForms.sitiosOrigenes.id;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarSitioDestino(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/sitios/lista?sitio=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listasForms.sitiosDestinos = respuesta;
            me.form.sitio_destino_id = me.listasForms.sitiosDestinos.id;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    selectSitioOrigen() {
      this.form.sitio_origen_id = "";
      this.form.sitio_origen = "";
      this.form.bloque_sitio_origen_id = "";
      if (this.sitioOrigen) {
        this.form.sitio_origen_id = this.sitioOrigen.id;
        this.form.sitio_origen = this.sitioOrigen.nombre;
        this.form.bloque_sitio_origen_id = this.sitioOrigen.bloque_id;
      }
    },

    selectSitioDestino() {
      this.form.sitio_destino_id = "";
      this.form.sitio_destino = "";
      this.form.bloque_sitio_destino_id = "";
      if (this.sitioDestino) {
        this.form.sitio_destino_id = this.sitioDestino.id;
        this.form.sitio_destino = this.sitioDestino.nombre;
        this.form.bloque_sitio_destino_id = this.sitioDestino.bloque_id;
      }
    },
  },
};
</script>
<style>
.modal .modal-dialog-aside {
  width: 300px;
  max-width: 80%;
  height: 100%;
  margin: 0;
  transform: translate(2);
  transition: transform 0.2s;
}
.modal .modal-dialog-aside .modal-content {
  height: inherit;
  border: 1;
  border-radius: 1;
}
.modal .modal-dialog-aside .modal-content .modal-body {
  overflow-y: auto;
}
.modal.fixed-left .modal-dialog-aside {
  margin-left: auto;
  transform: translateX(100%);
}
.modal.fixed-right .modal-dialog-aside {
  margin-right: auto;
  transform: translateX(-100%);
}
.modal.show .modal-dialog-aside {
  transform: translateX(0);
}
</style>
